export default "__VITE_ASSET__9cde05d8__"